"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EncodingCodes = void 0;

var _enum = _interopRequireDefault(require("enum"));

var EncodingCodes = new _enum.default({
  "O": "O"
}, {
  ignoreCase: true
});
exports.EncodingCodes = EncodingCodes;